import React from 'react';
import { PartyPopper, X } from 'lucide-react';
import { useBilling } from '../BillingContext';
import { useUser } from '@clerk/react';

/**
 * Shown once when a teacher resubscribes and their resources have been restored.
 */
export function WelcomeBackBanner() {
  const { billing, dismissWelcomeBanner } = useBilling();
  const { user } = useUser();

  const shouldShow = Boolean(
    billing.reactivatedAt &&
    !billing.welcomeBannerDismissed &&
    billing.status === 'active'
  );

  if (!shouldShow) return null;

  const firstName = user?.firstName ?? 'back';
  const count = billing.reactivationResourceCount ?? 0;

  return (
    <div className="mx-4 mt-4 rounded-2xl bg-gradient-to-r from-emerald-50 to-teal-50 border border-emerald-200 p-4 flex items-start gap-3">
      <div className="flex-shrink-0 w-9 h-9 rounded-xl bg-emerald-100 flex items-center justify-center">
        <PartyPopper size={18} className="text-emerald-600" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="font-semibold text-emerald-900 text-sm">
          Welcome back, {firstName}!
        </p>
        <p className="text-emerald-700 text-sm mt-0.5">
          {count > 0
            ? `We restored all ${count} of your resources. Glad to have you back.`
            : 'Glad to have you back. Your account is fully active again.'}
        </p>
      </div>
      <button
        onClick={dismissWelcomeBanner}
        className="flex-shrink-0 p-1 rounded-lg text-emerald-400 hover:text-emerald-600 hover:bg-emerald-100 transition-all"
        aria-label="Dismiss"
      >
        <X size={16} />
      </button>
    </div>
  );
}
